@if (initialized) {
    <div class="cn-reconciliation-container surface-0">

        <!-- Abgleich body (P3): statement entry, run reconciliation and Modell-Abgleich.
             All orchestration (createStatement / addLine / runReconciliation / abgleichVsModels
             via CnReconciliationApiService, the server-paged CommissionReconciliation result table
             with status colours from enum uiColor, drill-down and UI states) lives in the hosted
             component. The page shell only owns the routed skeleton + header. -->
        <mvs-cn-reconciliation-panel></mvs-cn-reconciliation-panel>

    </div>
}
